import React from 'react';

import { IComponent } from '../../../typings/generic-component';
import { DRIVERAVATAR, placeholdersMap } from '../../../utils/placeholders-motorsports';
import { makeClassNames } from '../../../utils/styles';
import Avatar from '../../atoms/avatar/avatar';
import Text from '../../atoms/text/text';
import './podium.scss';

const classNames = () =>
  makeClassNames({
    podiumContainer: 'podium__container',
    podiumBlock: 'podium__block',
    podiumDriverName: 'podium__driver-name',
    podiumDriverShortName: 'podium__driver-short-name',
    podiumDriverPosition: 'podium__driver-position',
    podiumPositionBlock: 'podium__position-block',
  });

export type PodiumItem = {
  customDriverName: string;
  customDriverShortName?: string;
  flagImgUrl?: string;
  driverImgUrl?: string;
  position: number;
};

export interface IPodium extends IComponent {
  podium: PodiumItem[];
}

const Podium = ({ podium }: IPodium) => {
  const cn = classNames();

  return (
    <div className={cn.podiumContainer}>
      {podium.map((driver) => (
        <div className={cn.podiumBlock} data-position={driver.position} key={driver.position}>
          {driver.driverImgUrl && (
            <Avatar
              imageUrl={driver.driverImgUrl}
              isCircled
              borderThickness={0}
              placeholder={placeholdersMap[DRIVERAVATAR]}
            />
          )}
          <Text color="light" fontSize="16" fontWeight="500" className={cn.podiumDriverName}>
            {driver.customDriverName}
          </Text>
          <Text color="light" fontSize="16" fontWeight="500" className={cn.podiumDriverShortName}>
            {driver.customDriverShortName}
          </Text>
          <div className={cn.podiumPositionBlock}>
            <Text color="light" fontWeight="500" className={cn.podiumDriverPosition}>
              {driver.position}&deg;
            </Text>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Podium;
